export const parseCarousel = (carousels, type = 'txt') => {
    switch (type) {
        case 'txt':
            return carouselToTxt(carousels);
        case 'html':
        case 'pdf':
            return carouselToHtml(carousels);
    }
};
/**
 * Converts a list of carousels to a text string. It also removes unneeded new line and let the parser handle it.
 * @param carousels - The list of carousels to convert
 * @returns A text string containing the carousels
 */
const carouselToTxt = (carousels) => {
    return carousels
        .map((carousel, index) => {
        const slidesText = carousel.slides
            .map((slide, slideIndex) => {
            return slideIndex === 0
                ? `\nTitle : ${slide.replace('\n', '')}\n`
                : `- Slide ${slideIndex}: ${slide.replace('\n', '')}`;
        })
            .filter(line => line !== '') // Remove empty lines for the first slide
            .join('\n');
        // return `Carousel ${index + 1}: ${carousel.title.replace('\n', '')}\n${slidesText}`;
        return `Carousel ${index + 1}: ${carousel.title.replace('\n', '')}\n${slidesText}`;
    })
        .join('\n\n'); // Add a blank line between carousels
};
/**
 * Converts a list of carousels to an HTML string.
 * @param carousels - The list of carousels to convert
 * @returns An HTML string containing the carousels
 */
const carouselToHtml = (carousels) => {
    return carousels
        .map((carousel, index) => {
        const slidesText = carousel.slides
            .map((slide, slideIndex) => {
            return slideIndex === 0
                ? `<li style="font-weight: bold;">Title: ${slide.replace('\n', '')}</li>`
                : `<li><span style="font-weight: bold;">Slide ${slideIndex}:</span> ${slide.replace('\n', '')}</li>`;
        })
            .filter(line => line !== '') // Remove empty lines for the first slide
            .join('');
        return `<h2>Carousel ${index + 1}: ${carousel.title.replace('\n', '')}</h2><ul>${slidesText}</ul>`;
    })
        .join(''); // Add a blank line between carousels
};
